// ===========================================================================
// 管理画面設定の「開いたあとに他の人が保存していた」（サーバの照合が外れた）
// ===========================================================================
// admin-config-save.js が投げ、設定ダイアログ・「全て保存」が受ける。
// ⚠ ここには何も import しない。受ける側（画面・テスト）が cms-axios（axios）まで
//   読み込まずに済むように、投げる側と分けてある。

// cms のセーバー・cms-client-admin と同じ値。
export const ADMIN_CONFIG_CONFLICT_CODE = 'U000132';

/**
 * currentVersion は今の保存版のトークン（「上書きして保存」で送り直すのに使う）。
 */
export class AdminConfigConflictError extends Error {
    constructor(currentVersion) {
        super('他の人がこの設定を保存しています');
        this.name = 'AdminConfigConflictError';
        this.conflict = true;
        this.currentVersion = currentVersion ?? '';
    }
}
